import React from 'react';
import useUtilizationPerMonthPerYearAverageChart from './hooks/useUtilizationPerMonthPerYearAverageChart';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';

export const UtilizationPerMonthPerYearAverage = ({ height = 400 }) => {
    const { series, subtitles } = useUtilizationPerMonthPerYearAverageChart();

    return (
        <SimpleBars
            decimals={0}
            series={series}
            values={[]}
            subtitles={subtitles}
            title={`Média da Utilização Mensal no Ano Selecionado`}
        />
    );
};
